import { z } from 'zod';

const CHANNEL_NAME = 'his-auth-session';

const SIGNED_OUT_MESSAGE = { type: 'signed-out' } as const;

const signedOutMessageSchema = z.object({
  type: z.literal(SIGNED_OUT_MESSAGE.type),
});

let channel: BroadcastChannel | undefined;

const getChannel = () => {
  if (typeof BroadcastChannel === 'undefined') return undefined;
  channel ??= new BroadcastChannel(CHANNEL_NAME);

  return channel;
};

export const broadcastSignedOut = () => {
  getChannel()?.postMessage(SIGNED_OUT_MESSAGE);
};

export const onSignedOutElsewhere = (listener: () => void) => {
  const handleMessage = (event: MessageEvent) => {
    if (signedOutMessageSchema.safeParse(event.data).success) listener();
  };

  getChannel()?.addEventListener('message', handleMessage);

  return () => getChannel()?.removeEventListener('message', handleMessage);
};
